export function getPageTitle(pathname: string): string {
  const routes: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/my-team': 'My Team',
    '/my-progress': 'My Progress',
    '/certification-courses': 'Certifications',
    '/all-courses': 'Course Catalog',
    '/resource-library': 'Resource Library',
    '/plans': 'Plans',
    '/billing': 'Billing',
    '/sign-in': 'Sign In',
    '/sign-up': 'Sign Up',
  };

  return routes[pathname] || 'REV LMS';
}

